import { render, staticRenderFns } from "./xfmzConfigInfos.vue?vue&type=template&id=3570279c&scoped=true"
import script from "./xfmzConfigInfos.vue?vue&type=script&lang=js"
export * from "./xfmzConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./xfmzConfigInfos.vue?vue&type=style&index=0&id=3570279c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570279c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3570279c')) {
      api.createRecord('3570279c', component.options)
    } else {
      api.reload('3570279c', component.options)
    }
    module.hot.accept("./xfmzConfigInfos.vue?vue&type=template&id=3570279c&scoped=true", function () {
      api.rerender('3570279c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/xfmzConfigInfos.vue"
export default component.exports